<template>
  <div>
    <el-dialog :width="Diawidth" :visible.sync="dialogVisible" :modal="false" v-dialogDrag :before-close="handleClose"
      :close-on-click-modal="true" :show-close="true" :close-on-press-escape="true">
      <ul class="Diatitles">
        <li v-for="(item,i) in titData" :key="i" :class="activelen==i?'active':''" @click="Click(item,i)">{{item.name}}</li>
      </ul>

      <img src="../../common/images/liucheng.png" class="liucheng" v-if="activelen==0" />

      <el-table :data="tableData" style="width: 100%;" height="530" v-if="activelen==1">
        <el-table-column prop="Levels" label="事件分级" width="100"></el-table-column>
        <el-table-column label="预警">
          <el-table-column prop="yuq" label="雨情" width="180"></el-table-column>
          <el-table-column prop="shuiq" label="水情" width="180"></el-table-column>
          <el-table-column prop="gongq" label="工情" width="180"></el-table-column>
        </el-table-column>
        <el-table-column prop="cuoshi" label="应急响应措施" width="201"></el-table-column>
        <el-table-column label="应急处置">
          <el-table-column prop="yjdd" label="应急调度" width="154"></el-table-column>
          <el-table-column prop="gcqx" label="工程抢险" width="154"></el-table-column>
          <el-table-column prop="ryzy" label="人员转移" width="154"></el-table-column>
        </el-table-column>
      </el-table>

      <img src="../../common/images/ryzylx.png" class="liucheng" v-if="activelen==2" />
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        titData: [
          {name: "应急响应流程", id: 0},
          {name: "分级响应表", id: 1},
          {name: "人员转移路线图", id: 2},
        ],
        activelen: 0,
        dialogVisible: true,
        Diawidth: "30%",
        tableData: [
          {
            Levels: "1级",
            yuq: "3h降水量达xxmm，中短期天气预报近期有较强降雨，可能出现特大暴雨。",
            shuiq: "3h降水量达xxmm，中短期天气预报近期有较强降雨，可能出现特大暴雨。",
            gongq: "3h降水量达xxmm，中短期天气预报近期有较强降雨，可能出现特大暴雨。",
            cuoshi: "3h降水量达xxmm，中短期天气预报近期有较强降雨，可能出现特大暴雨。",
            yjdd: "指挥长下达应急调度指令",
            gcqx: "指挥长下达应急调度指令",
            ryzy: "指挥长下达应急调度指令",
          },
          {
            Levels: "1级",
            yuq: "3h降水量达xxmm，中短期天气预报近期有较强降雨，可能出现特大暴雨。",
            shuiq: "3h降水量达xxmm，中短期天气预报近期有较强降雨，可能出现特大暴雨。",
            gongq: "3h降水量达xxmm，中短期天气预报近期有较强降雨，可能出现特大暴雨。",
            cuoshi: "3h降水量达xxmm，中短期天气预报近期有较强降雨，可能出现特大暴雨。",
            yjdd: "指挥长下达应急调度指令",
            gcqx: "指挥长下达应急调度指令",
            ryzy: "指挥长下达应急调度指令",
          },
          {
            Levels: "1级",
            yuq: "3h降水量达xxmm，中短期天气预报近期有较强降雨，可能出现特大暴雨。",
            shuiq: "3h降水量达xxmm，中短期天气预报近期有较强降雨，可能出现特大暴雨。",
            gongq: "3h降水量达xxmm，中短期天气预报近期有较强降雨，可能出现特大暴雨。",
            cuoshi: "3h降水量达xxmm，中短期天气预报近期有较强降雨，可能出现特大暴雨。",
            yjdd: "指挥长下达应急调度指令",
            gcqx: "指挥长下达应急调度指令",
            ryzy: "指挥长下达应急调度指令",
          },
          {
            Levels: "1级",
            yuq: "3h降水量达xxmm，中短期天气预报近期有较强降雨，可能出现特大暴雨。",
            shuiq: "3h降水量达xxmm，中短期天气预报近期有较强降雨，可能出现特大暴雨。",
            gongq: "3h降水量达xxmm，中短期天气预报近期有较强降雨，可能出现特大暴雨。",
            cuoshi: "3h降水量达xxmm，中短期天气预报近期有较强降雨，可能出现特大暴雨。",
            yjdd: "指挥长下达应急调度指令",
            gcqx: "指挥长下达应急调度指令",
            ryzy: "指挥长下达应急调度指令",
          },
          {
            Levels: "1级",
            yuq: "3h降水量达xxmm，中短期天气预报近期有较强降雨，可能出现特大暴雨。",
            shuiq: "3h降水量达xxmm，中短期天气预报近期有较强降雨，可能出现特大暴雨。",
            gongq: "3h降水量达xxmm，中短期天气预报近期有较强降雨，可能出现特大暴雨。",
            cuoshi: "3h降水量达xxmm，中短期天气预报近期有较强降雨，可能出现特大暴雨。",
            yjdd: "指挥长下达应急调度指令",
            gcqx: "指挥长下达应急调度指令",
            ryzy: "指挥长下达应急调度指令",
          }
        ]
      }
    },
    mounted() {

    },
    methods: {
      Click(item, i) {
        this.activelen = i;
        if (this.activelen == 1) {
          this.Diawidth = "70%";
        } else {
          this.Diawidth = "30%";
        }
      },

      handleClose(done) {
        this.dialogVisible = false;
        this.$emit("cancel", {
          "dialogVisible": this.dialogVisible
        })
      },

      cancel() { //取消
        this.dialogVisible = false;
        this.$emit("cancel", {
          "dialogVisible": this.dialogVisible
        })
      },
    }
  }
</script>

<style scoped>
  >>>.el-dialog {
    height: 600px;
  }

  >>>.el-dialog__body {
    height: 536px;
  }

  >>>.el-dialog__header {
    border: none;
    padding: 0;
  }

  .Diatitles {
    width: 100%;
    height: 30px;
    border-bottom: 1px solid #214e69;
    /* background-color: #ffe557; */
  }

  .Diatitles li {
  	float: left;
  	padding: 0px 20px;
  	line-height: 30px;
  	color: #fff;
  	font-size: 14px;
  	cursor: pointer;
  }

  .active {
  	color: #ffe557 !important;
    border-bottom: 1px solid #ffe557;
  }

  .liucheng {
    width: 456px;
    height: 435px;
    margin-top: 50px;
    margin-left: 40px;
  }

  >>>.el-table {
    margin-top: 10px;
    border-color: #0077AA;
    background-color: transparent !important;
  }

  >>>.el-table .cell {
  	text-align: center;
  	font-size: 14px;
    color: #eaeaea;
  }

  >>>.el-table th {
  	background-color: transparent !important;
    border-color: #0077AA;
  }

  >>>.el-table tr {
    background-color: transparent !important;
  }

  >>>.el-table td,
  >>>.el-table th.is-leaf {
    border-color: #0077AA;
  }

  >>>.el-table__body tr:hover>td {
  	background-color: transparent !important;
  }

  >>>.el-table--border::after,
  >>>.el-table--group::after,
  >>>.el-table::before {
    background-color: #0077AA;
  }
</style>
